define([
	'internal_util/Util',
	'service/WorkerPool'
], function (
	Util,
	WorkerPool
) {
	'use strict';

	function deriveKey(secret, salt, callbacks) {
		if (typeof secret === 'undefined') {
			secret = null;
		}
		if (secret === null || salt === '-1') {
			Util.callCallbacks(callbacks, {
				key : secret,
				salt : salt
			});

			return;
		}

		if (salt === null) {
			salt = Util.randomString();
		}

		WorkerPool.run('crypto', { secret : secret, salt : salt }, callbacks);
	}

	// Enable if key derivation with WebCrypto API is broadly
	// supported
	/*function deriveKey(secret, salt, callbacks) {
		var subtle;

		if (!window.crypto || !(window.crypto.subtle || window.crypto.webkitSubtle)
				|| secret === null) {
			Util.callCallbacks(callbacks, {
				key : secret,
				salt : null
			});

			return;
		}

		if (window.crypto.subtle) {
			subtle = window.crypto.subtle;
		} else {
			subtle = window.crypto.webkitSubtle;
		}

		if (salt === null) {
			salt = Util.stringToArrayBuffer(Util.randomString());
		} else {
			salt = Util.stringToArrayBuffer(salt);
		}

		try {
			subtle.importKey('raw', Util.stringToArrayBuffer(secret), { name : 'PBKDF2' }, false, [ 'deriveKey' ])
			.then(function (baseKey) {
				return subtle.deriveKey({
						name : 'PBKDF2',
						hash : 'SHA-1', // update to SHA-256 if supported on FF
						salt : salt,
						iterations : 1000
					}, baseKey, {
						name : 'AES-GCM',
						length : 256
					}, true, [ 'encrypt', 'decrypt' ]);
			})
			.then(function (aesKey) {
				return subtle.exportKey('raw', aesKey);
			})
			.then(function (keyBytes) {
				Util.callCallbacks(callbacks, {
					key : Util.arrayBufferToString(keyBytes),
					salt : Util.arrayBufferToString(salt)
				});
			})
			.catch(function (error) {
				Util.callCallbacks(callbacks, {
					key : secret,
					salt : null
				});
			});
		} catch (error) {
			Util.callCallbacks(callbacks, {
				key : secret,
				salt : null
			});
		}
	}*/

	return {
		deriveKey : deriveKey
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/CryptoUtil.js
// module id = 268
// module chunks = 6